import { render } from "./UnitList.vue?vue&type=template&id=f38322f0&scoped=true"
import script from "./UnitList.vue?vue&type=script&lang=js"
export * from "./UnitList.vue?vue&type=script&lang=js"

import "./UnitList.vue?vue&type=style&index=0&id=f38322f0&scoped=true&lang=stylus"
import "./UnitList.vue?vue&type=style&index=1&id=f38322f0&scoped=true&lang=stylus"

import exportComponent from "D:\\tokyo-shoseki_R6_0124\\06pk\\s\\5a\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f38322f0"]])

export default __exports__